import donutTheme from './donut-theme.json';

export type Theme = typeof donutTheme;

export const themes = {
  donut: donutTheme
};

// Default to donut theme
export default donutTheme; 